import { render, staticRenderFns } from "./Tpcheck-table.vue?vue&type=template&id=704ecabc&scoped=true"
import script from "./Tpcheck-table.vue?vue&type=script&lang=js"
export * from "./Tpcheck-table.vue?vue&type=script&lang=js"
import style0 from "./Tpcheck-table.vue?vue&type=style&index=0&id=704ecabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ecabc",
  null
  
)

export default component.exports